import React, { useState } from "react";
import { Link } from "react-router-dom";

const CandidateV1Area = ({ style_2 = false }) => {
  const [jobType, setJobType] = useState(style_2 ? "list" : "grid");
  const [showPass, setShowPass] = useState(false);

  const validateForm = (values) => {
    const errors = {};

    if (!values.prenom) {
      errors.prenom = "Prénom requis";
    }
    if (!values.nom) {
      errors.nom = "Nom requis";
    }
    if (!values.email) {
      errors.email = "Email requis";
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = "Email invalide";
    }
    if (!values.phone) {
      errors.phone = "Numéro de téléphone requis";
    }

    return errors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const values = {
      prenom: formData.get("prenom"),
      nom: formData.get("nom"),
      email: formData.get("email"),
      phone: formData.get("phone"),
    };

    const errors = validateForm(values);
    if (Object.keys(errors).length === 0) {
      alert("Form submitted successfully!");
    } else {
      alert("Validation errors: " + JSON.stringify(errors));
    }
  };

  return (
    <>
      <div className="hero-banner-two position-relative">
        <div className="container">
          <div className="position-relative pb-80 lg-pb-60  mt-10 d-flex flex-column justify-content-center align-items-center" style={{ paddingTop: '169px', paddingBottom: '20px' }}>
            <div className="navigation-step">
              <Link to="/rendez-vous1">
                <span className="precedent-text">{"< Précédent"}</span>
              </Link>
              <span>1/5</span>
              <Link to="/rendez-vous3">
                <span className="precedent-text">{"Suivant >"}</span>
              </Link>
            </div>
           
          </div>
        </div>
      </div>

      <section className="registration-section position-relative pt-100 lg-pt-80 pb-150 lg-pb-80" style={{ backgroundColor: '#FFF' }}>
        <div className="container">
        

        <div className="row">
              <div className="col-lg-12 col-md-8">
                <h2 className=" text-center" >Vos coordonnées pour vous contacter</h2>
                <h3 className="text-md mt-5 mb-5 lg-mb-30  fadeInUp text-center">Ces informations nous permettront de vous contacter pour répondre à vos questions</h3>
              </div>
            </div>
          <div className="user-data-form">
            <div className="form-wrapper m-auto">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-12">
                    <div className="input-group-meta position-relative mb-25">
                      <label htmlFor="prenom">Prénom*</label>
                      <input
                        type="text"
                        id="prenom"
                        name="prenom"
                        placeholder=""
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-group-meta position-relative mb-25">
                      <label htmlFor="nom">Nom*</label>
                      <input
                        type="text"
                        id="nom"
                        name="nom"
                        placeholder=""
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-group-meta position-relative mb-25">
                      <label htmlFor="email">Email*</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder=""
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="input-group-meta position-relative mb-25">
                      <label htmlFor="phone">Numéro de téléphone*</label>
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        placeholder=""
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-12 text-center mt-4">
                    <button
                      type="submit"
                      className="btn-eleven1 fw-500 tran3s d-block mt-20"
                    >
                      <Link to="/rendez-vous3" className="text-white">Continuer</Link>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    
    </>
  );
};

export default CandidateV1Area;
